import { gql } from '@apollo/client';

export const CONTENT_ITEM = gql`
query PageContent($input:NdPageContentInput!) {
  getNdPageContent(input:$input) {
    title
    ingress
    text
    image
    imageList {
      id
      key
      url
      name
      title
      description
      linkTo
    }
    seo {
      title
      text
      image
    }
    office {
      name
      urltag
    }
    config {
      showFrontpageNews
      showFrontpageService
      showStatistics
      showSubpageNews
      showSubpageServices
      showSubpageContact
      showSubpageProperties
      showSubpagePropertiesHighlight
    }
  }
}`;

export const CONFIG_ITEM = gql`
query getNdPageConfig($input:NdPageConfigInput!) {
  getNdPageConfig(input:$input) {
    showFrontpageNews
    showFrontpageService
    showStatistics
    showSubpageNews
    showSubpageServices
    showSubpageContact
    showSubpageProperties
    showSubpagePropertiesHighlight
  }
}`;